/**
 *  필수 값입니다.
 */
export const INVALID_REQUIRED_MESSAGE = '필수 값입니다.';

/**
 *  입력한 휴대전화번호가 올바르지 않습니다. 다시 입력해 주세요.
 */
export const INVALID_MOBILE_PHONE_MESSAGE = '입력한 휴대전화번호가 올바르지 않습니다. 다시 입력해 주세요.';
